module.exports = __webpack_public_path__ + "img/3.b3d0fca2.svg";